import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE = {
	percentageNumber: 'percentNumber',
	percentage: 'percent',
	amount: 'amount',
	clientName: 'clientName',
};

export interface RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE {
	percentageNumber: string;
	percentage: string;
	amount: string;
	clientName: string;
}
